import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useLocation, Link } from 'react-router-dom'
import styled from 'styled-components'
import BigNumber from 'bignumber.js/bignumber'
import { useWeb3React } from '@web3-react/core/core/core'
import { Heading, Flex, Skeleton, Text, Button, Box, Message, SubMenuItem, SubMenu, ChevronDownIcon, Card} from '@pancakeswap/uikit'
import orderBy from 'lodash/orderBy'
import partition from 'lodash/partition'
import { useTranslation } from 'contexts/Localization'
import usePersistState from 'hooks/usePersistState'
import { useFetchPublicPoolsData, usePools, useFetchCakeVault, useCakeVault  } from 'state/poolsDrop4/hooks'
import { usePool4 , usePool5, usePool6 , usePool7, usePool8 , usePool9, usePool10, usePool11, usePool12, usePool13, usePool14, usePool15, usePool16, usePool17, usePool18 , usePool19, usePool20, usePool21 , usePool22, usePool23, usePool24, usePool25, usePool26, usePool27, usePool29, usePool28, usePool30, usePool31, usePool32, usePool33, usePool34, usePool35, usePool36, usePool37, usePool38, usePool39, usePool40, usePool41, usePool42,usePool43, usePool44, usePool45, usePool47, usePool46, usePool48, useFaucet} from 'hooks/useTokenBalance'
import { usePollFarmsData , usePriceBnbBusd, usePriceCakeBusd , usePriceHVIBusd, usePriceLameaBusd , usePriceETCBusd , usePriceBABYVIZSLABusd , usePriceBVCBusd ,usePriceEXZOBusd , usePriceETHBusd, usePriceATALIRABusd, usePriceLTCBusd,usePriceliraBusd, usePriceLGCBusd, usePricebabyBusd } from 'state/farms/hooks'
import { getAddress, getHVIAddress , getCakeAddress, getWbnbAddress,geLiraAddress, getethAddress, getLAMEAAddress, getbvcAddress, getbabyvizslaAddress , getltcAddress, getetcAddress, getataliraAddress, getexzoAddress, getlgcAddress, getbabyAddress} from 'utils/addressHelpers'
import { getBalanceNumber, formatLocalisedCompactNumber, getFullDisplayBalance } from 'utils/formatBalance'
import { latinise } from 'utils/latinise'
import FlexLayout from 'components/Layout/Flex'
import Page from 'components/Layout/Page'
import PageHeader from 'components/PageHeader'
import SearchInput from 'components/SearchInput'
import Select, { OptionProps } from 'components/Select/Select'
import { Pool } from 'state/types'
import Loading from 'components/Loading'
import Balance from 'components/Balance'
import PoolCard from './components/PoolCard'
import CakeVaultCard from './components/CakeVaultCard'
import PoolTabButtons from './components/PoolTabButtons'
import BountyCard from './components/BountyCard'
import HelpButton from './components/HelpButton'
import InfoCard from './components/InfoCard'
import PoolsTable from './components/PoolsTable/PoolsTable'
import { ViewMode } from './components/ToggleView/ToggleView'
import { getAprData, getCakeVaultEarnings } from './helpers'
import BountyCard2 from './components/BountyCard2'

const CardLayout = styled(FlexLayout)`
  justify-content: center;
`

const PoolControls = styled(Flex)`
display: flex;
width: 100%;
align-items: center;
position: relative;

justify-content: space-between;
flex-direction: column;
margin-bottom: 35px;
background-color: rgb(19,47,46) ;
border-radius: 16px;

${({ theme }) => theme.mediaQueries.sm} {
  flex-direction: row;
    flex-wrap: wrap;
    border: solid 1.5px ${({ theme }) => theme.colors.cardBorder};
    padding: 20px 32px;
    margin-bottom: 50;
}
`
const Divider = styled.div`
  background-color: ${({ theme }) => theme.colors.backgroundDisabled};
  height: 1px;
  margin: 16px auto;
  width: 100%;
`
const ScrollBox = styled(Box)`
background-color: rgba(0,0,0);
padding: 10px;
width: 220px;
margin-top: 20px;
margin-bottom: -10px;
border: 0.05px solid ${({ theme }) => theme.colors.secondary};
border-radius: 10px;
${({ theme }) => theme.mediaQueries.md} {
  background-color: rgba(0,0,0);
  width: 220px;
  margin-bottom: -20px;
  padding: 10px;
  border: 0.05px solid ${({ theme }) => theme.colors.text};
  border-radius: 10px;
}
`
const ImageWrapper = styled.div`

margin: 0 auto;
margin-right: 5px;
${({ theme }) => theme.mediaQueries.md} {

  margin: 0 auto;
  margin-right: 5px;

}
`

const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 0px;

  ${({ theme }) => theme.mediaQueries.sm} {
    width: auto;
    padding: 0;
  }
`

const StyledModalContainer4 = styled(Card)`
  width: 100%;
  border: solid 1px ${({ theme }) => theme.colors.cardBorder};
  background-color: rgba(0,0,0);
}
  ${({ theme }) => theme.mediaQueries.md} {
    width: 100%;
    border: solid 1px ${({ theme }) => theme.colors.cardBorder};
    background-color: rgba(0,0,0);

`

const NUMBER_OF_POOLS_VISIBLE = 12

const Faucet3: React.FC = () => {
  const location = useLocation()
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const { pools: poolsWithoutAutoVault, userDataLoaded } = usePools(account)
  const [stakedOnly, setStakedOnly] = usePersistState(false, { localStorageKey: 'pancake_pool_staked' })
  const [numberOfPoolsVisible, setNumberOfPoolsVisible] = useState(NUMBER_OF_POOLS_VISIBLE)
  const [observerIsSet, setObserverIsSet] = useState(false)
  const loadMoreRef = useRef<HTMLDivElement>(null)
  const [viewMode, setViewMode] = usePersistState(ViewMode.TABLE, { localStorageKey: 'pancake_pool_view' })
  const [searchQuery, setSearchQuery] = useState('')
  const [sortOption, setSortOption] = useState('hot')
  const chosenPoolsLength = useRef(0)
  const {
    userData: { cakeAtLastUserAction, userShares },
    fees: { performanceFee },
    pricePerFullShare,
    totalCakeInVault,
  } = useCakeVault()
  const accountHasVaultShares = userShares && userShares.gt(0)
  const performanceFeeAsDecimal = performanceFee && performanceFee / 100

  const pools = useMemo(() => {
    const cakePool = poolsWithoutAutoVault.find((pool) => pool.sousId === 0)
    const cakeAutoVault = { ...cakePool, isAutoVault: true }
    return [cakeAutoVault, ...poolsWithoutAutoVault]
  }, [poolsWithoutAutoVault])


  const all = pools.filter((pool) => pool.sousId !== -1 && pool.tokensymbol5  === 'ALL110000')






  // TODO aren't arrays in dep array checked just by reference, i.e. it will rerender every time reference changes?
  const [finishedPools, openPools] = useMemo(() => partition(pools, (pool) => pool.isFinished), [pools])
  const stakedOnlyFinishedPools = useMemo(
    () =>
      finishedPools.filter((pool) => {
        if (pool.isAutoVault) {
          return accountHasVaultShares
        }
        return pool.userData && new BigNumber(pool.userData.stakedBalance).isGreaterThan(0)
      }),
    [finishedPools, accountHasVaultShares],
  )
  const stakedOnlyAllPools = useMemo(
    () =>
      all.filter((pool) => {
        if (pool.isAutoVault) {
          return accountHasVaultShares
        }
        return pool.userData && new BigNumber(pool.userData.stakedBalance).isGreaterThan(0)
      }),
    [all, accountHasVaultShares],
  )
  const hasStakeInFinishedPools = stakedOnlyFinishedPools.length > 0

  usePollFarmsData()
  useFetchCakeVault()
  useFetchPublicPoolsData()



  const handleChangeSearchQuery = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value)
  }

  const handleSortOptionChange = (option: OptionProps): void => {
    setSortOption(option.value)
  }

  const sortPools = (poolsToSort: Pool[]) => {
    switch (sortOption) {
      case 'apr':
        // Ternary is needed to prevent pools without APR (like MIX) getting top spot
        return orderBy(
          poolsToSort,
          (pool: Pool) => (pool.apr ? getAprData(pool, performanceFeeAsDecimal).apr : 0),
          'desc',
        )
      case 'earned':
        return orderBy(
          poolsToSort,
          (pool: Pool) => {
            if (!pool.userData || !pool.earningTokenPrice) {
              return 0
            }
            return pool.isAutoVault
              ? getCakeVaultEarnings(
                  account,
                  cakeAtLastUserAction,
                  userShares,
                  pricePerFullShare,
                  pool.earningTokenPrice,
                ).autoUsdToDisplay
              : pool.userData.pendingReward.times(pool.earningTokenPrice).toNumber()
          },
          'desc',
        )
      case 'totalStaked':
        return orderBy(
          poolsToSort,
          (pool: Pool) => (pool.isAutoVault ? totalCakeInVault.toNumber() : pool.totalStaked.toNumber()),
          'desc',
        )
      default:
        return poolsToSort
    }
  }


  return (
    <>
      <PageHeader>
        <Flex justifyContent="space-between" flexDirection={['column', null, null, 'row']}>
          <Flex flex="1" flexDirection="column" mr={['8px', 0]}>
          <Flex alignItems="center" justifyContent="space-between">
        <ImageWrapper>
        <img src="/images/pixel/pppp.png" alt="ifo bunny" width="100%" height="100%"/>
      </ImageWrapper>
      </Flex>
      <Message variant="warning"  mt="30px">
           <Box>
             <Text fontWeight="bold">{t('You must have at least 10,000 VIZSLASWAP tokens')}</Text>
             <Text as="p">{t('As a VIZSLASWAP Token owner, you have the opportunity to claim the tokens provided by partners and HVI every day.')}</Text>
           </Box>
         </Message>
      
          </Flex>
        </Flex>
      </PageHeader>
      <Page>
        <Flex alignItems="center" justifyContent="center" mb="30px">
      <BountyCard2 />

      </Flex>
      <Flex alignItems="center" justifyContent="center" >
      <StyledModalContainer4>
      <Flex alignItems="left" justifyContent="left"  ml="20px" mt="5px">
      <Text fontWeight="bold" color="isten" fontSize="16px">{t('Active Airdrops')}</Text>
      </Flex>

      <Flex alignItems="center" justifyContent="center" ml="15px" mt="5px">
        <ImageWrapper>
        <img src="/images/pixel/000.png" alt="ifo bunny" width="50px" height="50px"/>
      </ImageWrapper>
      <Flex flex="1" flexDirection="column" mr={['8px', 0]}>
      <Text  fontSize="15px">{t('50 VIZSLASWAP')}</Text>
      <Button  to="/airdrops"  as={Link} variant="text"  width="40px" height="20px" >
        {t('Claim')}
      </Button>
        </Flex>
      </Flex>
      <Flex alignItems="center" justifyContent="center" ml="15px" mt="5px">
        <ImageWrapper>
        <img src="/images/pixel/001.png" alt="ifo bunny" width="50px" height="50px"/>
      </ImageWrapper>
      <Flex flex="1" flexDirection="column" mr={['8px', 0]}>
      <Text  fontSize="15px">{t('75 LGC')}</Text>
      <Button  to="/airdropslgc"  as={Link} variant="text"  width="40px" height="20px" >
        {t('Claim')}
      </Button>
          </Flex>
      </Flex>
      <Flex alignItems="center" justifyContent="center" ml="15px" mb="5px" mt="5px">
        <ImageWrapper>
        <img src="/images/pixel/002.png" alt="ifo bunny" width="50px" height="50px"/>
      </ImageWrapper>
      <Flex flex="1" flexDirection="column" mr={['8px', 0]}>
      <Text  fontSize="15px">{t('2,500,000,000,000 HVI')}</Text>
      <Button  to="/airdropshvi"  as={Link} variant="text"  width="40px" height="20px" >
        {t('Claim')}
      </Button>
            </Flex>
      </Flex>
      <Flex alignItems="center" justifyContent="center" ml="15px" mt="5px">
        <ImageWrapper>
        <img src="/images/pixel/003.png" alt="ifo bunny" width="50px" height="50px"/>
      </ImageWrapper>
      <Flex flex="1" flexDirection="column" mr={['8px', 0]}>
      <Text  fontSize="15px">{t('1000 HMTT')}</Text>
      <Button  to="/airdropshmtt"  as={Link} variant="text"  width="40px" height="20px" >
        {t('Claim')}
      </Button>
        </Flex>
      </Flex>
      <Divider />
      <Flex alignItems="left" justifyContent="left" ml="20px" mt="5px">
      <Text fontWeight="bold" color="secondary" fontSize="16px">{t('Upcoming Airdrops')}</Text>
      </Flex>
      <Flex alignItems="center" justifyContent="center" ml="15px" mt="5px">
        <ImageWrapper>
        <img src="/images/pixel/005.png" alt="ifo bunny" width="50px" height="50px"/>
      </ImageWrapper>
      <Flex flex="1" flexDirection="column" mr={['8px', 0]}>
      <Text  fontSize="15px">{t('5,500,000 FartCoin')}</Text>
      <Button variant="text" disabled   width="40px" height="20px" >
        {t('Claim')}
      </Button>
        </Flex>
        </Flex>

      <Flex alignItems="center" justifyContent="center" ml="15px" mt="5px">
        <ImageWrapper>
        <img src="/images/pixel/004.png" alt="ifo bunny" width="50px" height="50px"/>
      </ImageWrapper>
      <Flex flex="1" flexDirection="column" mr={['8px', 0]}>
      <Text  fontSize="15px">{t('10,000 LAMEA')}</Text>
      <Button variant="text" disabled width="40px" height="20px" >
        {t('Claim')}
      </Button>
        </Flex>
      </Flex>


      </StyledModalContainer4>
      </Flex>
      </Page>
    </>
  )
}

export default Faucet3
